import { useMemo, useState } from "react";
import BeautyIcon from "../../../components/icons/BeautyIcon";
import FoodIcon from "../../../components/icons/FoodIcon";
import HealthSupplimentIcon from "../../../components/icons/HealthSupplimentIcon";
import PetIcon from "../../../components/icons/PetIcon";
import CategoryFocusltem from "./CategoryFocusltem"
import Detailltem from "./Detailltem"
import TeamMemberItem from "./TeamMemberItem";
import { Button, message } from "antd";
import DeleteModalSimple from "./DeleteModalSimple";
import { STATUS_INVITED } from "../../../constants/constants";
import AddEditTeamMemberModal from "./modals/AddEditTeamMemberModal";
import TeamMembers from "./TeamMembers";

interface Props {
  data: any
}
const BrandInfo = (props: Props) => {
  const { data } = props

  const categoriesList = useMemo(() => {
    return data?.brand_categories.map((item: any) => {
      switch (item?.focus_category) {
        case "Health Supplements":
          return (
            <CategoryFocusltem
              key={item?.id}
              title="Health Supplements"
              icon={<HealthSupplimentIcon />}
              items={item.sub_categories}
            />

          );

        case "Beauty & Skin":
          return (
            <CategoryFocusltem
              key={item?.id}
              title="Beauty & Skin"
              icon={<BeautyIcon />}
              items={item.sub_categories}
            />

          );

        case "Functional Food & Beverages":
          return (
            <CategoryFocusltem
              key={item?.id}
              title="Functional Food & Beverages"
              icon={<FoodIcon />}
              items={item.sub_categories}
            />

          );

        case "Pet Nutrition":
          return (
            <CategoryFocusltem
              key={item?.id}
              title="Pet Nutrition"
              icon={<PetIcon />}
              items={item.sub_categories}
            />
          );

        default:
          return <></>
      }
    })
  }, [data])



  return (
    <div className="grid grid-cols-3 gap-[16px]">
      <div className="col-span-2 rounded-[8px] p-[16px] bg-white">
        <div className="overflow-auto h-[calc(100vh-284px)]">
          <div className="mb-[40px]">
            <p className="text-[13px] font-[600] mb-[16px]">Trade Terms</p>
            <div className="grid grid-cols-4 gap-[20px]">
              <Detailltem label="Engagement Model" value={data?.brand_preference?.engagement_model?.join(", ")} />
              <Detailltem label="FOB/CIF Preference" value={data?.brand_preference?.fob_preference?.join(", ")} />
              <Detailltem label="Exclusivity Tenure" value={data?.brand_preference?.exclusivity_tenure} />
              <Detailltem label="Marketing Investment" value={data?.brand_preference?.marketing_investments} />
            </div>
          </div>
          <div className="flex flex-col gap-y-[16px]">
            <p className="text-[13px] font-[600] m-0">Category Focus</p>
            {categoriesList}
          </div>
        </div>
      </div>
      <TeamMembers orgId={data?.org_id} />

    </div>
  )
}

export default BrandInfo